/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * The content to render.
   */
  children: React.ReactNode;
};

const Styles = labelStyles('ModalMediaContent', {
  root: css`
    position: fixed;
    top: 80px;
    right: 0;
    bottom: 30px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (min-width: 650px) {
      right: auto;
      left: 50%;
      transform: translateX(-50%);
      width: min(calc(100% - (30px * 2)), 80vw);
      height: min(calc(100% - (80px + 30px)), 80vw);
    }

    img,
    iframe {
      object-fit: contain;
      max-width: 100%;
      max-height: 100%;
      // Use filter / drop-shadow over box-shadow to apply the
      // shadow to the actual rendered content, regardless of
      // how object-fit renders it.
      filter: drop-shadow(0px 20px 30px rgba(0, 0, 0, 0.5));
    }
  `,
});

export const ModalMediaContent = (props: Props) => {
  return <div css={Styles.root}>{props.children}</div>;
};
